import { Component, EventEmitter, inject, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HeaderPopupComponent } from '../header-popup/header-popup.component';

@Component({
  selector: 'cm-help',
  templateUrl: './help.component.html',
  styleUrls: ['../header-popup/header-popup.component.scss'],
})
export class HelpComponent extends HeaderPopupComponent {
  @Output() closeDialog = new EventEmitter<void>();
  public data = inject(MAT_DIALOG_DATA) as any;

  constructor(
    public dialogRef: MatDialogRef<HelpComponent>
  ) {
    super(dialogRef);
  }

  onCloseDialog(): void {
    this.closeDialog.emit();
  }
}
